import React from 'react';
import StarIcon, { StarIconProps, StarIconVariant, StrokeVariant } from '../star';

export interface RatingSelectorProps {
  value: number;
  onChange?: (value: number) => void;
  max?: number;
  disabled?: boolean;
  className?: string;
  starProps?: Partial<StarIconProps>;
  name?: string;
  ariaLabel?: string;
  strokeVariant?: StrokeVariant;
}

const RatingSelector: React.FC<RatingSelectorProps> = ({
  value,
  onChange,
  max = 5,
  disabled = false,
  className = '',
  starProps = {
    strokeVariant: 'matching',
  },
  name = 'rating',
  ariaLabel = 'Rating',
}) => {
  const handleClick = (idx: number) => {
    if (!disabled) {
      onChange?.(idx + 1);
    }
  };

  return (
    <div
      className={`rating-selector ${disabled ? 'pointer-events-none' : ''} ${className}`}
      role="radiogroup"
      aria-label={ariaLabel}
    >
      {Array.from({ length: max }).map((_, idx) => {
        let variant: StarIconVariant;
        if (value >= idx + 1) {
          variant = 'filled';
        } else if (disabled) {
          variant = 'disabled-empty';
        } else {
          variant = 'empty';
        }

        return (
          <label key={idx} className={`inline-block ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'} `}>
            <input
              className="peer sr-only"
              type="radio"
              name={name}
              value={idx + 1}
              checked={value === idx + 1}
              onChange={() => handleClick(idx)}
              disabled={disabled}
              aria-disabled={disabled}
              aria-label={`Rate ${idx + 1} star${idx === 0 ? '' : 's'}`}
            />
            <StarIcon
              className="peer-focus-visible:rounded peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-stroke-primary"
              variant={variant}
              ariaLabel={`Star ${idx + 1} ${value >= idx + 1 ? 'selected' : 'not selected'}`}
              {...starProps}
            />
          </label>
        );
      })}
    </div>
  );
};

export default RatingSelector;
